<udex-link
  class="navigation__medium--xl"
  (click)="openModal()"
  icon="it-host"
  icon-placement="start"
  design="Default"
  data-cy="license-material-deployment-systems"
>
  <span>{{ items?.length }} {{ header | cxTranslate: {count: items.length} }}</span>
</udex-link>

<ng-template #modalContentTemplate
  class="deployment-modal">
  <div content
    class="deployment-modal__content">
    <p class="deployment-modal__description body--xs udex-mb-4 udex-mb-lg-12">{{description | cxTranslate}}</p>

    <div class="deployment-modal__row d-none d-sm-flex body--xs ">
      <div *ngFor="let key of tenantKeys" class="deployment-modal__label ">
        <span class="deployment-modal__label-text udex-py-sm-8">{{ key.columnLabel | cxTranslate }}</span>
      </div>
    </div>

    <div class="deployment-modal__item d-flex flex-column udex-py-12 body--xs " *ngFor="let item of items">
      <div class="deployment-modal__row d-sm-flex deployment-modal__row--key">
        <div *ngFor="let key of tenantKeys" class="deployment-modal__label">
          <span class="deployment-modal__label-text d-sm-none udex-mb-4 udex-mb-sm-0">{{ key.columnLabel | cxTranslate }}</span>
          <span class="deployment-modal__label-value udex-mb-4 udex-mb-sm-0">{{ item[key.key] }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
